import React from "react";
import { fromJS } from "immutable";
import PurchasedPartWarning from "./PurchasedPartWarning";
import QuotedPartWarning from "./QuotedPartWarning";
import ExistingQuoteWarning from "./ExistingQuoteWarning";

export default (mostRecentQuotes, companyPartHistory) => {
  if (companyPartHistory.purchased_part) {
    return <PurchasedPartWarning {...companyPartHistory} />;
  } else if (companyPartHistory.quoted_part) {
    return <QuotedPartWarning {...companyPartHistory} />;
  } else if (mostRecentQuotes.length > 0) {
    return <ExistingQuoteWarning quote={fromJS(mostRecentQuotes[0])} />;
  }

  return null;
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/warnings.jsx